
import { defineComponent, ref, PropType } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import {
    ElectronicOperatorsListModel,
    useElectronicOperatorsModule
} from '@/modules/electronic-operators'
import { useRouter, useRoute } from 'vue-router'
import { ElectronicOperatorsRouteNames } from '@/router/routes-names'
import ElectronicOperatorsFormFieldName from '@/components/electronic-operators/form-fields/name.vue'
import ElectronicOperatorsFormFieldCode from '@/components/electronic-operators/form-fields/code.vue'

export default defineComponent({
    name: 'electronic-operators-new-electronic-operator',
    components: {
        ElectronicOperatorsFormFieldName,
        ElectronicOperatorsFormFieldCode
    },
    props: {
        electronicOperator: {
            type: Object as PropType<ElectronicOperatorsListModel>,
            required: true
        }
    },
    async setup (props) {
        const router = useRouter()
        const route = useRoute()
        const { submitForm, createOnSuccess } = useFormModule()
        const { updateElectronicOperator } = useElectronicOperatorsModule()

        const form = ref<QForm>()
        const electronicOperatorModel = ref(props.electronicOperator)

        const sendRequest = async () => {
            await updateElectronicOperator(props.electronicOperator.id, {
                name: electronicOperatorModel.value.name,
                code: electronicOperatorModel.value.code,
                electronicOperatorId: electronicOperatorModel.value.id.toString()
            })
        }

        const moveToList = () => router.push({ name: ElectronicOperatorsRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Electronic operator updated!')
        ).then(moveToList)

        return {
            form,
            electronicOperatorModel,
            onSubmit,
            ElectronicOperatorsRouteNames,
            route
        }
    }
})
